import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonLinkComponent } from './button-link/button-link.component';
import { DataGridComponent } from './data-grid/data-grid.component';
import { DialogBottomComponent } from './dialog-bottom/dialog-bottom.component';
import { DialogTopComponent } from './dialog-top/dialog-top.component';
import { GridMovementDiffComponent } from './grid-movement-diff/grid-movement-diff.component';
import { LoadIndicatorComponent } from './load-indicator/load-indicator.component';
import { OutOfServiceComponent } from './out-of-service/out-of-service.component';
import { PaginationComponent } from './pagination/pagination.component';
import { TabsComponent } from './tabs';
import { DocumentationViewerComponent } from './documentation-viewer/documentation-viewer.component';
import { FormContactUsComponent } from './form-contact-us/form-contact-us.component';
import { DialogContactUsComponent } from './dialog-contact-us/dialog-contact-us.component';
import { FileListComponent } from './file-list/file-list.component'
import { ScrollViewComponent } from './scroll-view/scroll-view.component';


@NgModule({
    imports: [
        CommonModule,
        LoadIndicatorComponent,
        PaginationComponent,
        DataGridComponent,
        DialogBottomComponent,
        DialogTopComponent,
        ButtonLinkComponent,
        OutOfServiceComponent,
        GridMovementDiffComponent,
        TabsComponent,
        DocumentationViewerComponent,
        FormContactUsComponent,
        DialogContactUsComponent,
        FileListComponent,
        ScrollViewComponent
    ],
    exports: [
        LoadIndicatorComponent,
        PaginationComponent,
        DataGridComponent,
        DialogBottomComponent,
        DialogTopComponent,
        ButtonLinkComponent,
        OutOfServiceComponent,
        GridMovementDiffComponent,
        TabsComponent,
        DocumentationViewerComponent,
        FormContactUsComponent,
        DialogContactUsComponent,
        FileListComponent,
        ScrollViewComponent
    ],
    declarations: [

    ]
})
export class ComponentsModule { }
